<div [@slideAnimation]="slide" [@.disabled]="!animate">
  <ng-content></ng-content>
</div>
<!--todo-->
<!--<div [@fadeAnimation]="slide" [@.disabled]="!animate" >-->
<!--  <ng-content></ng-content>-->
<!--</div>-->
